import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MenuPath, Note } from '../../touchpose/ui';
import { Steps } from './shared';

const LINK = 'text-blue-link no-underline font-medium';

const Body: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-[14px] leading-[1.75] text-content-secondary mb-[12px]">
    {children}
  </p>
);

const LicensingDoc: React.FC = () => {
  const { t } = useTranslation();

  /** Link to a sibling component page, labelled from the shared layout keys. */
  const page = (to: string, labelKey: string) => (
    <Link to={to} className={LINK}>
      {t(labelKey)}
    </Link>
  );

  return (
    <article className="font-body text-content-primary max-w-[760px]">
      <h1 className="font-display text-[28px] font-extrabold text-content-primary mb-[10px] tracking-[-0.4px]">
        {t('subdivsDocs.layout.licensing')}
      </h1>
      <Body>{t('subdivsDocs.licensing.intro')}</Body>
      <Note label={t('subdivsDocs.licensing.noteLabel')}>
        <Trans
          i18nKey="subdivsDocs.licensing.noteBody"
          components={{
            mp: (
              <Link to="/management" className={LINK}>
                {t('header.myProducts')}
              </Link>
            )
          }}
        />
      </Note>

      <h2
        id="activating"
        className="font-display text-[20px] font-bold text-content-primary mt-[36px] mb-[14px] tracking-[-0.3px]"
      >
        {t('subdivsDocs.licensing.activateTitle')}
      </h2>
      <Body>
        <Trans
          i18nKey="subdivsDocs.licensing.activateBody"
          components={{ menu: <MenuPath>Tools ▸ Squarebit Subdivs License…</MenuPath> }}
        />
      </Body>
      <Steps>
        <><Trans
            i18nKey="subdivsDocs.licensing.step1"
            components={{ b: <strong>License Key</strong> }}
          /></>
        <><Trans
            i18nKey="subdivsDocs.licensing.step2"
            components={{ b: <strong>Activate</strong> }}
          /></>
        <><Trans
            i18nKey="subdivsDocs.licensing.step3"
            components={{ b: <strong>● License active</strong> }}
          /></>
      </Steps>
      <Body>
        <Trans
          i18nKey="subdivsDocs.licensing.moveBody"
          components={{ b: <strong>Deactivate</strong> }}
        />
      </Body>

      <div className="border-t border-surface-hover mt-[36px] pt-[20px]">
        <Body>
          <Trans
            i18nKey="subdivsDocs.licensing.nextBody"
            components={{
              gc: page(
                '/squarebit-subdivs/docs/geometry-caches',
                'subdivsDocs.layout.geometryCaches'
              ),
              sk: page(
                '/squarebit-subdivs/docs/skeletal-meshes',
                'subdivsDocs.layout.skeletalMeshes'
              ),
              st: page(
                '/squarebit-subdivs/docs/static-meshes',
                'subdivsDocs.layout.staticMeshes'
              ),
              gr: page(
                '/squarebit-subdivs/docs/grooms',
                'subdivsDocs.layout.grooms'
              )
            }}
          />
        </Body>
      </div>
    </article>
  );
};

export default LicensingDoc;
